export default __webpack_public_path__ + "static/pragicts-secops-services-edge-computing-security-bf557c8f292ae23f016e17d59a8037a8.jpg";